import styled from "styled-components";
import { TrashIconWrapper } from "../CaptionBlock/styles";
import { Colors } from "@smartsuite/types";

export const StyleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  &:hover {
    ${TrashIconWrapper} {
      visibility: visible;
    }
  }

  .picker-input-field {
    padding-top: 0;
    padding-left: 0;
    padding-right: 30px;
  }

  .pill-picker-editor__editor {
    padding-left: 6px;
  }

  .picker-input-field__pill {
    margin-top: 3px;
    margin-left: 6px;
    max-width: 98%;
  }

  .picker-input-field__pill + .picker-input-field__input {
    margin-left: 4px;
  }

  .pill-picker-error {
    border-color: ${Colors.bRed};
  }
`;
